import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';

import { LogoutComponent } from "../components/logout/logout";
import { SafePipe } from "./pipes/safe";
import { ClickOutsideDirective } from "./directives/click-outside.directive";
import { PhoneRegexDirective } from "./directives/phone-regex.directive";
import { RemoveZeroOnFocusDirective } from "../components/remove-zero-on-focus/remove-zero-on-focus";
//import { IonicSelectableComponent } from 'ionic-selectable';

// change from component to module
//import { IonicSelectableModule } from "../shared/ionic-selectable-module";

import { MapViewerComponent } from "../components/map-viewer/map-viewer";

import { WorkOrderConfirmComponent } from "../components/work-order-confirm/work-order-confirm";
import { LeggTilProduktComponent } from "../components/legg-til-produkt/legg-til-produkt";
import { LeggTilProduktSalesComponent } from "../components/legg-til-produkt-sales/legg-til-produkt-sales";
import { WorkLeggTilProduktComponent } from "../components/work-legg-til-produkt/work-legg-til-produkt";
import { TruckTrailerChangeComponent } from "../components/truck-trailer-change/truck-trailer-change";
import { OrderlineSplitComponent } from "../components/orderline-split/orderline-split";
import { OrderConfirmComponent } from "../components/order-confirm/order-confirm";
import { OrderNextDayConfirmComponent } from "../components/order-next-day-confirm/order-next-day-confirm";
import { OrderConfirmSalesComponent } from "../components/order-confirm-sales/order-confirm-sales";
import { NewMessageComponent } from "../components/new-message/new-message";
import { MapMarkerComponent } from "../components/map-marker/map-marker";
import { ForgotPasswordComponent } from "../components/forgot-password/forgot-password";
import { EgneTankerConfirmComponent } from "../components/egne-tanker-confirm/egne-tanker-confirm";
import { EditOrderSharedComponent } from "../components/edit-order-shared/edit-order-shared";
import { CustomerSearchComponent } from "../components/customer-search/customer-search/customer-search.component";
import { CustomerSignComponent } from "../components/customer-sign/customer-sign";
import { CustomerAddressSearchComponent } from "../components/customer-address-search/customer-address-search/customer-address-search.component";
import { ConvertProductComponent } from "../components/convert-product/convert-product";
import { BeholdningLagreConfirmComponent } from "../components/beholdning-lagre-confirm/beholdning-lagre-confirm";
import { DrivingInstructionsComponent } from "../components/driving-instructions/driving-instructions";
import { SearchModalComponent } from "../pages/landax-form/search-modal/search-modal.component";
import { IonicSelectableComponent } from "ionic-selectable";
import { PickerModalComponent } from "../components/picker-modal/picker-modal.component";

@NgModule({
  declarations: [
    LogoutComponent,
    SafePipe,
    RemoveZeroOnFocusDirective,
    ClickOutsideDirective,
    PhoneRegexDirective,
    MapViewerComponent,
    WorkOrderConfirmComponent,
    LeggTilProduktComponent,
    WorkLeggTilProduktComponent,
    TruckTrailerChangeComponent,
    OrderlineSplitComponent,
    OrderConfirmComponent,
    OrderNextDayConfirmComponent,
    OrderConfirmSalesComponent,
    NewMessageComponent,
    MapMarkerComponent,
    LeggTilProduktSalesComponent,
    ForgotPasswordComponent,
    EgneTankerConfirmComponent,
    EditOrderSharedComponent,
    CustomerSearchComponent,
    CustomerSignComponent,
    CustomerAddressSearchComponent,
    ConvertProductComponent,
    BeholdningLagreConfirmComponent,
    DrivingInstructionsComponent,
    SearchModalComponent,
    PickerModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule,
    IonicSelectableComponent,
    AngularSignaturePadModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule,
    LogoutComponent,
    SafePipe,
    RemoveZeroOnFocusDirective,
    ClickOutsideDirective,
    PhoneRegexDirective,
    IonicSelectableComponent,
    MapViewerComponent,
    WorkOrderConfirmComponent,
    LeggTilProduktComponent,
    WorkLeggTilProduktComponent,
    TruckTrailerChangeComponent,
    OrderlineSplitComponent,
    OrderConfirmComponent,
    OrderNextDayConfirmComponent,
    OrderConfirmSalesComponent,
    NewMessageComponent,
    MapMarkerComponent,
    LeggTilProduktSalesComponent,
    ForgotPasswordComponent,
    EgneTankerConfirmComponent,
    EditOrderSharedComponent,
    CustomerSearchComponent,
    CustomerSignComponent,
    CustomerAddressSearchComponent,
    ConvertProductComponent,
    BeholdningLagreConfirmComponent,
    DrivingInstructionsComponent,
    SearchModalComponent,
    PickerModalComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA], // <— allow custom elements like <ion-*> or <app-*>
})
export class SharedModule {}
